<template>
  <section class="app-main">
    <transition name="fade" mode="out-in">
      <!-- <router-view :key="key"></router-view> -->
         <router-view></router-view>
    </transition>
  </section>
</template>
<script>
export default {
  name: 'AppMain',
  computed: {
    // key() {
    //   return this.$route.name !== undefined ? this.$route.name + +new Date() : this.$route + +new Date()
    // }
  },
  mounted() {
    // setInterval(() => {
    //   this.$notify.close()
    //   this.$notify.success({
    //     title: 'Info',
    //     message: '这是一条没有关闭按钮的消息'
    //   })
    // }, 10000)
  },
  methods: {
    getTask() {

    }
  }
}
</script>

<style scoped>
.app-main {
  /*50 = navbar  */
  height: calc(100vh - 57px);
  position: relative;
  overflow: auto;
}
</style>
